import { render, staticRenderFns } from "./AttachTriggerToParam.vue?vue&type=template&id=3bfebfa1"
import script from "./AttachTriggerToParam.vue?vue&type=script&lang=js"
export * from "./AttachTriggerToParam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports